import React from 'react';
import style from './Index.module.css';
import ReactPaginate from "react-paginate";

class DisplayListPagination extends React.Component {

    render = () => {
        let keyName = this.props.keyName || 'entries';
        let meta = this.props && this.props.meta ? this.props.meta : null;
        let currentPage = meta && meta.current_page !== undefined && meta.current_page !== null
            ? Number(meta.current_page)
            : 1;
        let safeCurrentPage = Number.isFinite(currentPage) && currentPage > 0 ? currentPage : 1;
        let pageCount = meta && Number.isFinite(Number(meta.last_page)) ? Number(meta.last_page) : 0;

        return (
            <div className="row" style={{ zIndex: this.props?.zIndex ? 2 : 999 }}>
                <div className="col">
                    {meta ? `Showing ${meta.from || 0} to ${meta.to || 0} of ${meta.total} ${keyName}` : ``}
                </div>
                <div className="col">
                    <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={0}
                        forcePage={Math.max(0, safeCurrentPage - 1)}
                        onPageChange={this.props.onPageChange}
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="pagination justify-content-end"
                        pageClassName="page-item"
                        nextClassName="page-item"
                        previousClassName="page-item"
                        pageLinkClassName="page-link"
                        nextLinkClassName="page-link"
                        previousLinkClassName="page-link"
                        activeClassName="active"
                    />
                </div>
            </div>
        );
    };
}

export default DisplayListPagination;